<template>
  <div id="app">
  <router-view></router-view>
    <BottomNav />
  </div>
</template>

<script>
import BottomNav from './components/BottomNav.vue'

export default {
  name: 'App',
  components: {
    BottomNav
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f5f5f5;
}

button {
  border: none;
  outline: none;
  font-family: inherit;
}

button:not(:disabled) {
  cursor: pointer;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

html, body {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: fixed; /* 防止移动端滚动 */
  touch-action: manipulation; /* 改善触摸体验 */
  -webkit-tap-highlight-color: transparent; /* 移除触摸高亮 */
}

/* 响应式调整 */
@media (max-width: 767px) {
  html {
    font-size: 14px; /* 移动端字体稍小 */
  }
  
  input[type="range"] {
    height: 24px; /* 移动端滑块更大，更易触摸 */
  }
  
  button {
    min-height: 36px; /* 确保按钮足够大，易于点击 */
  }
}
</style>
